import copy from 'clipboard-copy'

const methods = {
  methods: {
    setBadges () {
      this.getExternalData('badge-generator.json', 'badges', 'GET', () => {
        const config = this.$config
        this.badges.unshift({
          subject: config.appName,
          status: config.version,
          icon: 'radioactive'
        })
      })
    },
    oneMonthFromNow () {
      return new Date(Date.now() + 2.628e+9)
    },
    getLoremIpsumRawContent (length = 20) {
      this.text = this.stripHtmlTags(Array.from(Array(length).keys()).map(() => {
        return this.$refs['lorem-ipsum'].item()
      }).join(''))
    },
    kebabToCamelCase (string, classCase) {
      let arr = string.split('-')
      let capital = arr.map((item, index) => index ? item.charAt(0).toUpperCase() + item.slice(1).toLowerCase() : item.toLowerCase())
      let capitalString = capital.join('')
      return classCase ? this.firstLetterCapital(capitalString) : capitalString
    },
    copyToClipboard (value) {
      copy(value).then(() => {
        this.copiedValue = value
        this.snackbar = true
      })
    },
    format (bytes, decimals = 2) {
      if (bytes === 0) {
        return '0 Bytes'
      }
      const k = 1024
      const dm = decimals < 0 ? 0 : decimals
      const sizes = [
        'Bytes',
        'KB',
        'MB',
        'GB',
        'TB',
        'PB',
        'EB',
        'ZB',
        'YB'
      ]
      const i = Math.floor(Math.log(bytes) / Math.log(k))
      return parseFloat((bytes / Math.pow(k, i)).toFixed(dm)) + ' ' + sizes[i]
    },
    getScroll () {
      if (window.pageYOffset !== undefined) {
        return [pageXOffset, pageYOffset]
      } else {
        let sx
        let sy
        let d = document
        let r = d.documentElement
        let b = d.body
        sx = r.scrollLeft || b.scrollLeft || 0
        sy = r.scrollTop || b.scrollTop || 0
        return [sx, sy]
      }
    },
    getRandomArrayItem (items) {
      return items[Math.floor(Math.random() * items.length)]
    },
    isEven (value) {
      return value % 2 === 0
    },
    pathSplit () {
      return this.$route.path.split('/')
    },
    firstLetterCapital (str) {
      return typeof str === 'string' ? str.replace(/^\w/, c => c.toUpperCase()) : ''
    },
    storeLocalSetting (key, value) {
      let settings = this.getLocalSettings()
      if (!settings) {
        settings = {
          dark: false,
          color: null,
          colorLightness: null,
          nightShift: false
        }
      }
      settings[key] = value
      localStorage.setItem('settings', JSON.stringify(settings))
    },
    getLocalSettings () {
      return JSON.parse(localStorage.getItem('settings'))
    },
    getRepoLink () {
      return this.$config.repository.url
    },
    log (event = 'click', component = '', data = null, callback, command = 'log') {
      console[command](`@${event}`, component, data)
      if (typeof callback === 'function') {
        callback.call(this)
      }
    },
    getExternalData (url = '', key = '', method = 'GET', callback = null) {
      this.$http({
        url: `${this.$config.demosMeta}${url}`,
        method
      }).then(response => {
        if (response.status === 200 && response.data) {
          this[key] = response.data
          this.$nextTick(() => {
            if (typeof callback === 'function') {
              callback.call(this)
            }
          })
        }
      }).catch(error => {
        console.log(error)
      })
    },
    setPageTitle (pageTitle = '', delimiter = ' | ') {
      document.title = `${pageTitle ? pageTitle + delimiter : ''}${this.$config.appName}`
    },
    toggleFullScreen () {
      if (!document.fullscreenElement) {
        document.documentElement.requestFullscreen()
        this.fullScreen = true
      } else {
        if (document.exitFullscreen) {
          document.exitFullscreen()
          this.fullScreen = false
        }
      }
    },
    scrollToTop () {
      this.doScroll()
    },
    scrollToElement (selector) {
      selector = document.querySelector(selector)
      if (selector) {
        selector.scrollIntoView()
      }
    },
    getNavigationSection (section = 'ui') {
      return this.$router.options.routes.filter(item => item.type === section)
    },
    doScroll (x = 0, y = 0) {
      window.scrollTo(x, y)
    },
    addMetaTags (description = '', keywords = []) {
      const metaDescription = document.querySelector('meta[name="description"]')
      const metaKeywords = document.querySelector('meta[name="keywords"]')
      if (metaDescription) {
        metaDescription.setAttribute('content', this.stripHtmlTags(description))
      }
      if (metaKeywords) {
        metaKeywords.setAttribute('content', keywords.join(', '))
      }
    },
    stripHtmlTags (html = '') {
      const container = document.createElement('DIV')
      container.innerHTML = html
      return container.textContent || container.innerText || ''
    },
    viewport () {
      const w = window
      const d = document
      const e = d.documentElement
      const g = d.getElementsByTagName('body')[0]
      const width = w.innerWidth || e.clientWidth || g.clientWidth
      const height = w.innerHeight || e.clientHeight || g.clientHeight
      return {
        width,
        height
      }
    },
    enableRoutePush (selector = '.bcq-static-content') {
      const pageLinks = document.querySelectorAll(`${selector} [v-link]`)
      const allLinks = document.querySelectorAll(`${selector} a`)
      const router = this.$router
      const colors = this.$root.colors
      const bgColorLightness = colors.bgColorLightness
      const classes = [this.$dark && colors.primary === 'black' ? 'text-white' : `text-${colors.primary}${bgColorLightness ? '-' + bgColorLightness : ''}`, 'underline', 'font-semibold']
      pageLinks.forEach(a => {
        a.onclick = (e) => {
          const href = a.getAttribute('href')
          e.preventDefault()
          router.push({
            path: href
          })
        }
      })
      allLinks.forEach(a => {
        a.removeAttribute('class')
        a.classList.add(...classes)
        a.classList.add(...classes)
      })
    }
  }
}

export default methods



// WEBPACK FOOTER //
// ./src/mixins/methods.js